import { Injectable } from '@angular/core';
import {ApiClient} from "../core/api-client.service";
import {AdminSettingsUpdateRequest} from "./DTOs/AdminSettingsUpdateRequest";
import {Observable} from "rxjs";
import {AdminValue} from "./DTOs/AdminValue";
import {LoginInfo} from "../core/LoginInfo";
import {LoginSettingsUpdateRequest} from "./DTOs/LoginSettingsUpdateRequest";

@Injectable({
  providedIn: 'root'
})
export class SuperAdminSettingsService {
  readonly relativeBase = "super-admin-settings/";

  constructor(private http: ApiClient) { }

  UpdateUserSettings(req: AdminSettingsUpdateRequest) {
    return this.http.post(this.relativeBase + "update-settings", req);
  }

  UpdateLoginSettings(req: LoginSettingsUpdateRequest) {
    return this.http.post(this.relativeBase + "update-login-settings", req);
  }

  GetUserSettings() : Observable<AdminValue[]> {
    return this.http.get(this.relativeBase + "get-admin-settings");
  }

  GetLoginInfo() : Observable<LoginInfo> {
    return this.http.get(this.relativeBase + "get-login-settings");
  }

  uploadLoginPhoto(formData: FormData) {
    return this.http.post(this.relativeBase + "upload", formData);
  }
  GetLoginPhoto(): Observable<LoginInfo> {
      return this.http.get(this.relativeBase + "get-login-photo");
  }
}
